import React, { useState, useRef, useEffect } from 'react';
import UserManagementSearchbar from '../../Pages/User Management/userManagementSearchbar';
import SearchBar from './SearchBar';

// import img from "../../assets/PortalIconnographySVGs/PortalAppRealted_Icons/Power Search/__Search.svg";

import classes from './PowerSearch.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { PowerSearch, UserPowerSearch } from '../../Api Methods/Api';
import DataManager from '../../hooks/DataManager';
import postRequest from '../../Api Methods/Request Methods/postRequest';

const FilterUsersSearch = ({ searchQuery, setSearchQuery, setIsLoading, placeholder, setFilteredResults, handleFilterLogic, categories, reset, setReset, portalAdmin, setPortalAdmin, appAdmin, setAppAdmin, pageSize, setPageSize, pageOffset, setPageOffset }) => {
    const dispatch = useDispatch();
    const [categoryFilter, setCategoryFilter] = useState([]);
    const dataManager = new DataManager()
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const [resultCount, setResultCount] = useState(0)

    const ApiData = {
        token,
        client
    }

    const formRef = useRef();

    const timer = useRef();

    /*const type = [
        "Portal admin",
        "App admin",
        "Standard user",
    ] */


    useEffect(() => {

        console.log(appAdmin)
        console.log(portalAdmin)

        const HandleUserSearch = async (ApiData, query) => {

            let body = {
                "query": query,
                "portalAdmin": portalAdmin,
                "appAdmin": appAdmin,
                "pageSize": pageSize,
                "pageOffset": pageOffset
            }

            console.log(body)
            
            timer.current = Date.now();
            const triggerTime = timer.current;
            const responseData = await UserPowerSearch(ApiData, body, dispatch);
            const users = responseData[0].users;
            setResultCount(responseData[0].totalCount.resultCount)
            if (timer.current == triggerTime) {
                handleFilterLogic(users, searchQuery, categoryFilter);
                
                if (users != null) {
                    //setIsLoading(false);
                }
            }

        }

        const delayDebounceFn = setTimeout(() => {
            //   Perform fetch call with the input value
            if (searchQuery !== "") {
                //setIsLoading(true)
                dataManager.setItem('userSearchQuery', searchQuery)
                HandleUserSearch(ApiData, searchQuery)
            } else if (dataManager.getItem('userSearchQuery') == ""){
                //HandleUserSearch(ApiData, "")
                console.log("hit")
                setReset(reset+1)
                setResultCount(0)
            }
        }, 1700);


        return () => clearTimeout(delayDebounceFn);
    }, [searchQuery, categoryFilter, appAdmin, portalAdmin]);


    return (
        <form className={classes.form} ref={formRef} onSubmit={(e) => e.preventDefault()}>
            <div className={classes.searchContainer}>
                <UserManagementSearchbar
                    placeholder={placeholder}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                    setCategoryFilter={setCategoryFilter}
                    showFilterButton={true}
                    reset={reset}
                    appAdmin={appAdmin}
                    setAppAdmin={setAppAdmin}
                    portalAdmin={portalAdmin}
                    setPortalAdmin={setPortalAdmin}
                />            
            </div>
            
            
            {resultCount != 0 && <p>Total results: {resultCount}</p>}
        </form>
    );
};

export default FilterUsersSearch;
